import useAssessmentsFinished from "./useAssessmentsFinished";
import useAssessmentPageBlock from "./useAssessmentPageBlock";
import useLang from "../../../hooks/useLang";

const useFinishedList = () => {
  const lang = useLang();
  const assessments = useAssessmentsFinished();

  const items = useAssessmentPageBlock({ assessments });

  const page = {
    hasAccess: assessments?.hasAccess,
    header: {
      title: assessments?.isLoading
        ? lang("assessments.assessments_loading")
        : lang("assessments_finished.title"),
    },
    paging: { ...assessments?.pagination },
    items,
  };
  return page;
};

export default useFinishedList;
